import rest from "@/rest-client";
import createCrudVuexModule from "@/store/crud";
import Vue from "vue";

export const sectorDepartment = createCrudVuexModule({
  namespaced: true,
  path: "/quick-hierarchy/sector-department",

  state: {
    editedEntity: undefined,
  },
  getters: {
    copingEntity: (state) => state.copingEntity ?? {},
  },
  actions: {
    async create({ getters, commit, dispatch }, payload) {
      try {
        commit("isUpdating", true);
        payload = await dispatch("preparePayload", {
          editedEntity: getters.editedEntity,
          form: payload,
        });

        const response = await rest.post(`/quick-hierarchy/sector-department`, payload);
        commit("editedEntity", undefined);
        return response;
      } finally {
        commit("isUpdating", false);
      }
    },
    async update({ getters, commit, dispatch }, payload) {
      try {
        commit("isUpdating", true);
        payload = await dispatch("preparePayload", {
          editedEntity: getters.editedEntity,
          form: payload,
        });

        const response = await rest.put(`/quick-hierarchy/sector-department`, payload);

        commit("editedEntity", undefined);
        return response;
      } finally {
        commit("isUpdating", false);
      }
    },
    async multipleDelete({ state, commit }, array) {
      const success = [];
      const failed = [];

      for (const item of array) {
        try {
          await rest.delete(`/quick-hierarchy/sector-department/${item._id}`);
          success.push(Vue.filter("translate")(item.sector.name) + "-" + Vue.filter("translate")(item.department.name));
        } catch (error) {
          failed.push({ name: Vue.filter("translate")(item.sector.name) + "-" + Vue.filter("translate")(item.department.name), error: error.data.message });
        }
      }

      commit("deleteOperationResult", {
        success: success,
        failed: failed,
      });
    },
  },
});

export const workspaceSectorDepartment = createCrudVuexModule({
  namespaced: true,
  path: "/workspace/quick-hierarchy/sector-department",

  state: {
    editedEntity: undefined,
  },
  getters: {
    copingEntity: (state) => state.copingEntity ?? {},
  },
  actions: {
    async save({ dispatch, getters }, payload) {
      payload = await dispatch("preparePayload", {
        editedEntity: getters.editedEntity,
        form: payload,
      });

      if (payload._id) {
        return dispatch("update", payload);
      } else {
        return dispatch("create", payload);
      }
    },
    async create({ getters, commit, dispatch }, payload) {
      try {
        commit("isUpdating", true);

        const response = await rest.post(`/workspace/quick-hierarchy/sector-department`, payload);
        commit("editedEntity", undefined);
        return response;
      } finally {
        commit("isUpdating", false);
      }
    },
    async update({ getters, commit, dispatch }, payload) {
      try {
        commit("isUpdating", true);

        const response = await rest.put(`/workspace/quick-hierarchy/sector-department`, payload);

        commit("editedEntity", undefined);
        return response;
      } finally {
        commit("isUpdating", false);
      }
    },
    async multipleDelete({ state, commit }, array) {
      const success = [];
      const failed = [];

      for (const item of array) {
        try {
          await rest.delete(`/workspace/quick-hierarchy/sector-department/${item._id}`);
          success.push(Vue.filter("translate")(item.datasource.name) + "-" + Vue.filter("translate")(item.data.name));
        } catch (error) {
          failed.push({ name: Vue.filter("translate")(item.datasource.name) + "-" + Vue.filter("translate")(item.data.name), error: error.data.message });
        }
      }

      commit("deleteOperationResult", {
        success: success,
        failed: failed,
      });
    },
  },
});
